<button *ngIf="themeModeService.enabled" mat-icon-button type="button" [matTooltip]="label()" [attr.aria-label]="label()" (click)="themeModeService.toggle()">
  <mat-icon fontSet="project-titan" [fontIcon]="fontIcon()"></mat-icon>
</button>
